import { render, staticRenderFns } from "./dj-media-label.vue?vue&type=template&id=120026aa&scoped=true&"
import script from "./dj-media-label.vue?vue&type=script&lang=js&"
export * from "./dj-media-label.vue?vue&type=script&lang=js&"
import style0 from "./dj-media-label.vue?vue&type=style&index=0&id=120026aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120026aa",
  null
  
)

export default component.exports